// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-catalog-order_list',
    // #endregion
    // #region Properties
    data: () => ({
        category: {},
        orderList: {},
        products: [],
        cart: {
            totalQuantity: 0,
            lines: []
        },
        isLoading: false
    }),
    computed: {
        orderListID() {
            return this.$route.params.orderListID;
        },
    },
    // #endregion
    // #region Boostrap
    created() {
        this.loadData();
    },
    beforeMount() {
        this.$host.eventBus.on('refresh', this.loadData);
    },
    beforeUnmount() {
        this.$host.eventBus.off('refresh', this.loadData);
    },
    // #endregion
    // #region Watch
    watch: {
        "$route.params.orderListID"(value) {
            this.loadData();
        },
    },
    // #endregion
    // #region Core
    methods: {
        async loadData() {
            // #region Check
            if (utils.isEmpty(this.orderListID)) {
                return;
            }
            // #endregion
            // #region Loading
            this.isLoading = true;
            // #endregion
            // #region Run
            try {
                //Run
                let tResult = await host.api.get(`commerce/order-lists/${this.orderListID}`);
                //Breadcrumbs
                if (tResult.data?.breadcrumbs) {
                    this.$store.commit('navigation/setBreadcrumb', tResult.data.breadcrumbs);
                }
                //Data
                this.orderList = tResult.data;
                this.products = tResult.data.products;
                //Lines
                this.products.forEach((e) => {
                    e.__cart_quantity = 1;
                    e.__cart_comment = '';
                });
                //Internal
                this.isLoading = false;
            }
            catch (e) {
                this.isLoading = false;
                host.notification.showToast(utils.getAxiosErrorMessage(e));
            }
            // #endregion
        },
        OnRefresh(event) {
            // #region Run
            //Default
            event.preventDefault();
            //Notify
            this.$host.eventBus.emit('refresh');
            // #endregion
        },
        canOrder(product) {
            // #region Check
            if (!product) {
                return false;
            }
            if (!product.canOrder) {
                return false;
            }
            // #endregion
            return true;
        },
        async OnAddToCart(product) {
            // #region Check
            if (!product || !product.canOrder) {
                return;
            }
            if (product.__cart_quantity === 0) {
                return;
            }
            // #endregion
            // #region Data
            let tOrder = {
                lines: [{
                        itemType: 'SKU',
                        itemNumber: product.itemNumber,
                        quantity: product.__cart_quantity,
                        singlePrice: product.price,
                        userData: {
                            comment: product.__cart_comment,
                        },
                    }]
            };
            // #endregion
            // #region Send
            try {
                // #region Meter
                this.isLoading = true;
                // #endregion
                // #region Send
                let tResult = await host.api.put(`commerce/order-lists/${this.orderListID}`, tOrder);
                // #endregion
                // #region Reset
                product.__cart_quantity = 1;
                product.__cart_comment = '';
                // #endregion
                // #region Result
                if (tResult.data) {
                    this.orderList = tResult.data;
                }
                // #endregion
                // #region Meter
                this.isLoading = false;
                // #endregion
                host.notification.showToast("Artikel wurde übernommen");
            }
            // #endregion
            // #region Error
            catch (e) {
                // #region Meter
                this.isLoading = false;
                // #endregion
                host.notification.showToast(utils.getAxiosErrorMessage(e));
            }
            // #endregion
        },
        async OnDeleteLine(line) {
            // #region Check
            if (!line) {
                return;
            }
            // #endregion
            // #region Send
            try {
                // #region Meter
                this.isLoading = true;
                // #endregion
                // #region Send
                let tResult = await host.api.delete(`commerce/order-lists/${this.orderListID}/lines/${line.lineID}`);
                // #endregion
                // #region Result
                if (tResult.data) {
                    this.orderList = tResult.data;
                }
                // #endregion
                // #region Meter
                this.isLoading = false;
                // #endregion
            }
            // #endregion
            // #region Error
            catch (e) {
                // #region Meter
                this.isLoading = false;
                // #endregion
                host.notification.showToast(utils.getAxiosErrorMessage(e));
            }
            // #endregion
        },
        async OnCommentEdit() {
            let tData = {
                callback: () => this.loadData(),
                comment: this.orderList.comment,
                cartID: this.orderList.listID
            };
            host.notification.showModal(host.components.getComponent('g-cart-comment-dialog'), tData, { size: 'default' });
        },
        async OnListSend() {
            if ((await host.actions.tryExecute('288a.commerce.orderlist.send', { cartNumber: this.orderList.number, cartID: this.orderList.listID })).isSucceeded === true) {
                this.$router.push({ path: '/service/order-lists' });
            }
        },
    }
    // #endregion
});
// #endregion
